var React = require('react');

function LeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.45261 8.18397e-07L-4.72849e-07 5.5L5.45261 11L7 9.43916L3.09364 5.5L7 1.56084L5.45261 8.18397e-07Z","fill":"#404043"}));
}

LeftInline.defaultProps = {"width":"7","height":"11","viewBox":"0 0 7 11","fill":"none"};

module.exports = LeftInline;

LeftInline.default = LeftInline;
